import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import TextField from 'material-ui/TextField';

const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 2,
    boxSizing: 'border-box',
  },
  label: {
    position: 'relative',
  },
  helper: {
    textAlign: 'right',
  },
  helperError: {
    color: '#f00',
  },
  inputDisabled: {
    color: theme.palette.text.primary,
  },
});

const TextareaWidget = props => {
  const { classes, id, options, value } = props;

  if (!value) return null;

  return (
    <TextField
      className={classes.root}
      disabled
      readOnly
      fullWidth
      id={id}
      //label={label}
      multiline
      rows={options.rows}
      labelClassName={classes.label}
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        classes: { inputDisabled: classes.inputDisabled },
      }}
      rowsMax={options.rows}
      value={value === undefined ? '' : value}
    />
  );
};

TextareaWidget.defaultProps = {
  autofocus: false,
  options: {
    rows: 4,
  },
};

TextareaWidget.propTypes = {
  classes: PropTypes.object.isRequired,
  schema: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.shape({
    rows: PropTypes.number,
  }),
  value: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  autofocus: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
};

export default withStyles(styles)(TextareaWidget);



// WEBPACK FOOTER //
// ./src/modules/common/components/form/widgets/readonly/TextareaWidget.js